import TextDialog from './TextDialog';



export default TextDialog;
